import React, {Component, createRef} from 'react';
import classNames from 'classnames';
import './FJSlider.less';
import FJCoreUtil from "../../../core/util/FJCoreUtil";

const percentStyle = (progress) => {
    return progress * 100 + '%';
};

class FJSlider extends Component {

    constructor(props) {
        super(props);
        let {defaultValue = 0, min = 0, max = 100, vertical = false, range} = props;
        defaultValue = range ? (defaultValue ? defaultValue : [min, max]) :  defaultValue;
        this.tagProgress = 0;
        this.state = {
            progress: range ? [defaultValue[0] / max, defaultValue[1] / max] : defaultValue / max, // 0 -> 1
            defaultValue: defaultValue,
            min: min,
            max: max,
            isDragging: false,
            vertical: vertical,
        };
        this.container = createRef();
    }

    componentDidMount() {
        if (this.props.useNative) {
            FJCoreUtil.addEvent(this.container.current, 'mousedown', this.onMouseDown);
        }
    }

    onMouseDown = (e) => {
        this.setState({
            isDragging: true,
            progress: this.convertToProgress(e),
        }, () => {
            FJCoreUtil.addEvent(document.body, 'mousemove', this.onMouseMove);
            FJCoreUtil.addEvent(document.body, 'mouseup', this.onMouseUp);
            this.onBeforeChange();
            this.onChange();
        });
    };
    onMouseMove = (e) => {
        this.setState({
            progress: this.convertToProgress(e),
        }, () => {
            this.onChange();
        });
    };
    onMouseUp = () => {
        this.setState({
            isDragging: false,
        }, () => {
            FJCoreUtil.removeEvent(document.body, 'mousemove', this.onMouseMove);
            FJCoreUtil.removeEvent(document.body, 'mouseup', this.onMouseUp);
            this.onAfterChange();
        });
    };
    onBeforeChange = () => {
        let {onBeforeChange} = this.props;
        if (onBeforeChange) {
            onBeforeChange(this.getValue(), this.getProgress());
        }
    };
    onChange = () => {
        let {onChange} = this.props;
        if (onChange) {
            onChange(this.getValue(), this.getProgress());
        }
    };
    onAfterChange = () => {
        let {onAfterChange} = this.props;
        if (onAfterChange) {
            onAfterChange(this.getValue(), this.getProgress());
        }
    };
    getValue = () => {
        let {progress, min, max} = this.state;
        let duration = max - min;
        return this.props.range ? [duration * progress[0], duration * progress[1]] : duration * progress;
    };
    setValue = (value) => {
        let {min, max} = this.state;
        let duration = max - min;
        if (this.props.range) {
            this.setState({progress: [value[0] / duration, value[1] / duration]});
        } else {
            this.setState({progress: value / duration});
        }
    };
    getProgress = () => {
        return this.state.progress;
    };
    setProgress = (progress, callback) => {
        this.setState({progress: progress}, () => {
            if (callback) {
                callback();
            }
        });
    };
    convertToProgress = (e) => {

        if (!this.container.current) {
            return;
        }

        let point = {
            left: e.clientX,
            top: e.clientY,
        };
        let rect = this.container.current.getBoundingClientRect();

        let getHorPointProgress = (point, rect) => {
            let pointValue = point.left - rect.left;
            pointValue = FJCoreUtil.valueOfInterval(pointValue, 0, rect.width);
            return pointValue / rect.width;
        };

        if (this.props.range) {
            let pointProgress = getHorPointProgress(point, rect);
            let progress = this.state.progress;
            if (e.type === 'mousedown') {
                if (Math.abs(pointProgress - progress[0]) < Math.abs(pointProgress - progress[1])) {
                    this.tagProgress = progress[1];
                } else {
                    this.tagProgress = progress[0];
                }
            }
            return [this.tagProgress, pointProgress].sort((a, b) => {
                return a - b;
            });
        } else {
            let value;
            let progress;
            if (this.state.vertical) {
                value = rect.top + rect.height - point.top;
                value = FJCoreUtil.valueOfInterval(value, 0, rect.height);
                progress = value / rect.height;
            } else {
                value = point.left - rect.left;
                value = FJCoreUtil.valueOfInterval(value, 0, rect.width);
                progress = value / rect.width;
            }
            return progress;
        }
    };


    render () {
        let {range, className='', disabled} = this.props;
        let {vertical, progress} = this.state;
        progress = typeof this.props.progress === 'undefined' ? progress : this.props.progress;
        let sliderClass = classNames('c-slider', className, {'c-vertical': vertical, 'c-horizontal': !vertical,'c-cursor':!disabled});
        let trackStyle = {};
        let handleStyle = {};
        let handleMinStyle = {};
        let handleMaxStyle = {};
        if (range) {
            handleMinStyle.left = percentStyle(progress[0]);
            handleMaxStyle.left = percentStyle(progress[1]);
            trackStyle.width = percentStyle(progress[1] - progress[0]);
            trackStyle.left = handleMinStyle.left;
        } else {
            if (vertical) {
                trackStyle.height = percentStyle(progress);
                handleStyle.bottom = percentStyle(progress);
            } else {
                trackStyle.width = percentStyle(progress);
                handleStyle.left = percentStyle(progress);
            }
        }
        let disabledClass = classNames('c-slider-handle', {'c-slider-handle-disable': disabled});
        return (
          <div className={sliderClass}
               ref={this.container}
               onMouseDown={(e) => {
                   if (this.props.useNative) {
                       return;
                   }
                   this.onMouseDown(e);
               }}
          >
              <div className='c-slider-rail' />
              <div className='c-slider-track'
                   style={trackStyle}
              />
              {
                  range ?
                    <div>
                        <div className='c-slider-handle'
                             style={handleMinStyle}
                        />
                        <div className='c-slider-handle'
                             style={handleMaxStyle}
                        />
                    </div> :
                    <div className={disabledClass}
                         style={handleStyle}
                    />
              }
          </div>
        );
    }
}

export default FJSlider;
